(function defineFormValidation($, w) {
  "use strict";

  var cache = {
    onKeyup: {},
    onBlur : {}
  };

  var errorSummaryContainer = '<div class="errorSummary error isHidden"></div>';
  var errorMessageRowForMandatoryCheckboxes = '<div class="row errorMessageRow"><div class="error errorMessage"></div></div>';
  var errorMessageRowForGeneralInput = '<div class="row errorMessageRow"><div class="error small-offset-4 large-offset-4 small-8 large-8 columns errorMessage"></div></div>';

  // Refactor this one somehow:
  var formErrorMessageRows  = {
    'row singleField email_bill_agreement': function () { return errorMessageRowForMandatoryCheckboxes; },
    'row singleField legal_agreement'     : function () { return errorMessageRowForMandatoryCheckboxes; },
    'default'                             : function () { return errorMessageRowForGeneralInput; }
  };

  var expirationDateFieldValues = {
    creditcard: {
      month: function expirationDateFieldValuesCreditcardMonth() {
        return parseInt(document.getElementById('Checkout_Payment_CreditcardForm_ccExpirationMonth').value, 10);
      },
      year: function expirationDateFieldValuesCreditcardYear() {
        return parseInt(document.getElementById('Checkout_Payment_CreditcardForm_ccExpirationYear').value, 10);
      }
    },
    mrcash: {
      month: function expirationDateFieldValuesMrcashMonth() {
        return parseInt(document.getElementById('Checkout_Payment_MrcashForm_ccExpirationMonth').value, 10);
      },
      year: function expirationDateFieldValuesMrcashYear() {
        return parseInt(document.getElementById('Checkout_Payment_MrcashForm_ccExpirationYear').value, 10);
      }
    }
  };

  var elementForExpirationErrorMessage = {
    creditcard: function () {
      return $('#Checkout_Payment_CreditcardForm_ccExpirationYear');
    },
    mrcash: function () {
      return $('#Checkout_Payment_MrcashForm_ccExpirationMonth');
    }
  };

  var handledCardTypes = {
    creditcard: true,
    mrcash: true
  };

  // ****************** //
  // Private functions: //
  // ****************** //

  function getFormErrorMessageRowFor(formRowClasses) {
    if (typeof formErrorMessageRows[formRowClasses] === 'function') {
      return formErrorMessageRows[formRowClasses]();
    } else {
      return formErrorMessageRows['default']();
    }
  }

  function removeExpirationErrorMessages(cardType) {
    var $paymentMethodsContainer = $('#paymentMethodsContainer');
    var cardTypeUpperFirst = cardType.charAt(0).toUpperCase() + cardType.slice(1);

    $paymentMethodsContainer.find('.errorMessageRow.Checkout_Payment_' + cardTypeUpperFirst + 'Form_ccExpirationMonth').remove();
    $paymentMethodsContainer.find('.errorMessageRow.Checkout_Payment_' + cardTypeUpperFirst + 'Form_ccExpirationYear').remove();
  }

  function getExpirationDateFieldValues(cardType, valueFor) {
    cardType = cardType.toLowerCase();
    if (typeof expirationDateFieldValues[cardType] === 'object' && typeof expirationDateFieldValues[cardType][valueFor] === 'function') {
      return expirationDateFieldValues[cardType][valueFor]();
    } else {
      throw new Error('ERROR: FormValidation.getExpirationDateFieldValues - unhandled cardType ' + cardType + ' and/or valueFor ' + valueFor + '!');
    }
  }

  function showExpirationErrorFor(cardType) {
    var $elementForExpirationErrorMessage = elementForExpirationErrorMessage[cardType.toLowerCase()]();
    var errorMessage = $elementForExpirationErrorMessage.data('error-message-past-date');

    setErrorForElement($elementForExpirationErrorMessage, errorMessage);
  }

  function ccNumberInputErrorExists() {
    var $paymentMethodsContainer = $("#paymentMethodsContainer");
    var ccNumberInputErrorsCount = $paymentMethodsContainer
       .find(".errorMessageRow")
       .filter(".CCNumberInputField1, .CCNumberInputField2, .CCNumberInputField3, .CCNumberInputField4").length;

    return (ccNumberInputErrorsCount > 0);
  }

  function validateFormFieldOnKeyup($formField, validationData) {
    var validationState = getValidationState($formField, validationData, 'onkeyup');

    if (validationState !== 'invalid_show_error') {
      unsetErrorForElement($formField);
    }

    $formField.trigger("setValidationData", [validationState]);

    return (validationState === 'valid');
  }

  function validateFormFieldOnBlur($formField, validationData) {
    var validationState = getOnBlurValidationState($formField, validationData);

      var closest = $formField.closest('.j-validation-group');
      if ($formField.attr('data-input-type') === 'select' && closest.attr('data-validation-state') === 'invalid_show_error') {
          if (closest.next().hasClass('errorMessageRow')) {
              closest.next().remove();
          }
      }

    switch (validationState) {
      case 'valid':
        unsetErrorForElement($formField);
        break;
      case 'invalid_no_error':
        if (validationData.showAllInvalidErrors === true) {
          setErrorForElement($formField, validationData.validationRequiredMessage);
        }
        break;
      case 'invalid_show_error':
        if ($formField.is("input:checkbox") && validationData.showAllInvalidErrors === true) {
          setErrorForElement($formField, validationData.validationRequiredMessage);
        } else {
          setErrorForElement($formField, validationData.errorMessage);
        }
        break;
      default:
        console.log('ERROR: Unmatched validationState "' + validationState + '" in FormValidation.validateFormFieldOnBlur');
    }


    validationData.showAllInvalidErrors = false;
    $formField.trigger("setValidationData", [validationState]);

    return (validationState === 'valid');
  }

  function getValidationState($formField, validationData, eventType) {
    switch (eventType) {
      case 'onkeyup':
        return getOnKeyUpValidationState($formField, validationData);
      case 'onblur':
        return getOnBlurValidationState($formField, validationData);
    }

    return false;
  }

  function getOnKeyUpValidationState($formField, validationData) {
    var validationState;
    var fieldValue = $formField.val();

    if (fieldValue.length === 0) {
      if (validationData.emptyOrValidate) {
        validationState = 'valid';
      } else {
        validationState = 'invalid_no_error';
      }
    } else if (hasInvalidCharacters($formField, validationData, 'onkeyup')) {
      validationState = 'invalid_show_error';
    } else if (isInputTooShort($formField, validationData)) {
      validationState = 'invalid_no_error';
    } else {
      validationState = 'valid';
    }

    return validationState;
  }

  function getOnBlurValidationState($formField, validationData) {
    var validationState;
    var fieldValue = $formField.val();

    if ((fieldValue.length === 0)) {
      if (validationData.emptyOrValidate) {
        validationState = 'valid';
      } else {
        validationState = 'invalid_no_error';
      }
    } else if (isInputTooShort($formField, validationData) || hasInvalidCharacters($formField, validationData, 'onblur')) {
      validationState = 'invalid_show_error';
    } else {
      validationState = 'valid';
    }

    return validationState;
  }

  function hasInvalidCharacters($formField, validationData, eventType) {
    var invalidCharacters = false;
    var formFieldId       = $formField.attr("id");
    var fieldValue        = $formField.val();
    var regex;

    switch (eventType) {
      case 'onkeyup':
        if (fieldValue.length && validationData.keyupValidationRegex) {
          regex = cache.onKeyup[formFieldId] || (cache.onKeyup[formFieldId] = new RegExp(validationData.keyupValidationRegex,
             validationData.validationRegexModifiers || ''));

          if (! regex.test(fieldValue)) {
            invalidCharacters = true;
          }
        }
        break;
      case 'onblur':
        if (validationData.validationRegex) {
          if (formFieldId === "CCNumberInputField4") {
            // In this case the validation regex has to be created dynamically every time,
            // because it depends on the credit card type which is determined by other input fields
            regex = new RegExp(validationData.validationRegex, validationData.validationRegexModifiers || '');
          } else {
            regex = cache.onBlur[formFieldId] ||
               (cache.onBlur[formFieldId] = new RegExp(validationData.validationRegex, validationData.validationRegexModifiers || ''));
          }

          if (! regex.test(fieldValue)) {
            invalidCharacters = true;
          }
        }
    }

    return invalidCharacters;
  }

  function isInputTooShort($formField, validationData) {
    var isTooShort = false;
    var inputValue = $formField.val();
    var $formRow;

    if (validationData.hasOwnProperty('validationLengthMin') && inputValue.length < validationData.validationLengthMin) {
      isTooShort = true;
    } else {
      $formRow = getFormRowOfFormElement($formField);

      if ((
            $formField.is("input:checkbox") &&
            !$formField.prop("checked")
         ) ||
         (
            $formField.is("input:radio") &&
            $formRow.find("input:radio[name='" + $formField.attr("name") + "']:checked").length === 0
         )) {
        isTooShort = true;
      }
    }

    return isTooShort;
  }

  function setErrorForElement($element, errorMessage) {
    if (typeof $element === "object") {
      if (typeof errorMessage !== "string") {
        errorMessage = $element.data("error-message");
      }

      var $row = getFormRowOfFormElement($element);
      $row.trigger("setValidationData", ['invalid_show_error']);
      showErrorMessageBelowElement(errorMessage, $element, $row);
    }
  }

  function unsetErrorForElement($element) {
    if (typeof $element === "object") {
      var $row = getFormRowOfFormElement($element);

      if ($row.hasClass("j-validation-group")) {
        $row.trigger("setValidationData", ['valid']);
      }

      removeErrorMessageBelowElement($element, $row);
    }
  }

  function showErrorMessageBelowElement(errorMessage, $inputElement, $rowElement) {
    var $messageContainer;
    var $messageElement;

    // Do not show more than one error message for the four CC number input fields:
    if ($inputElement.hasClass('ccNumber')) {
      if (ccNumberInputErrorExists()) {
        return false;
      }
    }

    if (typeof $rowElement !== "object") {
      $rowElement = getFormRowOfFormElement($inputElement);
    }

    $messageContainer = getErrorMessageContainerBelowElement($inputElement, $rowElement);
    $messageElement   = $messageContainer.find(".errorMessage");

    $messageElement.html(errorMessage);
  }

  function removeErrorMessageBelowElement($inputElement, $rowElement) {
    if (typeof $rowElement !== "object") {
      $rowElement = getFormRowOfFormElement($inputElement);
    }

    var inputFieldIdentifier = getFieldIdentifierOf($inputElement);
    var className            = w.THEME.Utils.cleanCSSClassName(inputFieldIdentifier);
    var $messageContainer    = $rowElement.siblings("." + className);

    $messageContainer.remove();
  }

  function getErrorMessageContainerBelowElement($inputElement, $rowElement) {
    var inputFieldIdentifier = getFieldIdentifierOf($inputElement);
    var className = w.THEME.Utils.cleanCSSClassName(inputFieldIdentifier);
    var $messageContainer = $rowElement.siblings("." + className);
    var messageContainerExists = $messageContainer.length > 0;
    var errorMessageRow;
    
    if ($rowElement.next().hasClass('errorMessageRow')) {
        $rowElement = $rowElement.next();
    }

    if (!messageContainerExists) {
      errorMessageRow = getFormErrorMessageRowFor($rowElement.attr('class'));
      $messageContainer = $(errorMessageRow).insertAfter($rowElement);
      $messageContainer.addClass(className); // Add the input field name as class, so that the error message container can be removed later
    }

    return $messageContainer;
  }

  function getErrorSummaryContainer($parentContainer) {
    var $errorSummary = $parentContainer.find(".errorSummary");
    var $continueButtonContainer;

    if ($errorSummary.length === 0) {
      $continueButtonContainer = $parentContainer.find(".continueButtonContainer");

      if ($continueButtonContainer.length > 0) {
        $errorSummary = $(errorSummaryContainer).insertBefore($continueButtonContainer);
      } else {
        $errorSummary = $(errorSummaryContainer).appendTo($parentContainer);
      }
    }

    return $errorSummary;
  }

  function getFieldIdentifierOf($inputElement) {
    // The credit card fields get their name attribute removed, so we need to use their IDs then:
    var inputFieldIdentifier = $inputElement.attr("name") || $inputElement.attr("id");

    return inputFieldIdentifier;
  }

  function isMonthAndYearFuture(month, year) {
    var currentDate;
    var currentMonth;
    var currentYear;
    var isFuture = false;

    if (typeof year === 'number' && typeof month === 'number') {
      currentDate = new Date();
      currentMonth = currentDate.getMonth() + 1;
      currentYear = currentDate.getFullYear();

      if ((year > currentYear) || ((year === currentYear) && (month >= currentMonth))) {
        isFuture = true;
      }
    }

    return isFuture;
  }

  function validateKlarnaSubform() {
    // Make sure the birthdate is at least 18 years before the current date:
    //var birthdateValid = true;
    //var maximumDate;
    //var minimumAgeInYears = 18;
    var birthdayDate = getBirthdayDateForKlarna();
    var $inputElementWithErrorData = $('#Checkout_Payment_KlarnainvoiceForm_birthdayDay');
    var errorMessage;
    var $paymentMethodsContainer;

    if (birthdayDate === false) {
      errorMessage = $inputElementWithErrorData.data('validation-required-message');
      setErrorForElement($inputElementWithErrorData, errorMessage);
      return false;
    }

    $paymentMethodsContainer = $("#paymentMethodsContainer");
    $paymentMethodsContainer.find(".errorMessageRow.Checkout_Payment_KlarnainvoiceForm_birthdayDay_").remove();
    $paymentMethodsContainer.find(".errorMessageRow.Checkout_Payment_KlarnainvoiceForm_birthdayMonth_").remove();
    $paymentMethodsContainer.find(".errorMessageRow.Checkout_Payment_KlarnainvoiceForm_birthdayYear_").remove();

    return true;

    /*
         * Clarified, We don't want to validate this info yet, possibly will later *


        maximumDate = new Date();
        normalizeDate(maximumDate);
        subtractYearsFromDate(minimumAgeInYears, maximumDate);

        if (birthdayDate.getTime() > maximumDate.getTime()) {
            errorMessage = $inputElementWithErrorData.data('error-message-minimum-age');
            setErrorForElement($inputElementWithErrorData, errorMessage);
            birthdateValid = false;
        }



        return birthdateValid;
    */
  }

  function getBirthdayDateForKlarna() {
    var birthdayDate;
    var DOMBirthdayDaySelect   = document.getElementById('Checkout_Payment_KlarnainvoiceForm_birthdayDay');
    var DOMBirthdayMonthSelect = document.getElementById('Checkout_Payment_KlarnainvoiceForm_birthdayMonth');
    var DOMBirthdayYearSelect  = document.getElementById('Checkout_Payment_KlarnainvoiceForm_birthdayYear');

    var birthdayDay   = parseInt(DOMBirthdayDaySelect.value, 10);
    var birthdayMonth = parseInt(DOMBirthdayMonthSelect.value, 10);
    var birthdayYear  = parseInt(DOMBirthdayYearSelect.value, 10);

    if (isNaN(birthdayDay) || isNaN(birthdayMonth) || isNaN(birthdayYear)) {
      return false;
    }

    birthdayDate = new Date(birthdayYear + "/" + (birthdayMonth - 1) + "/" + birthdayDay);

    return birthdayDate;
  }

  /*
  function subtractYearsFromDate(years, date) {
      date.setMonth(date.getMonth() - years * 12);
  }

  function normalizeDate(date) {
      // Set all time values to 0
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
  }
  */

  // ***************** //
  // Public functions: //
  // ***************** //

  function init() {
    // Do nothing;
  }

  function initForm($form) {
    var value;
    var $inputField;

    if ($form.length) {
      $form.find("input, select, textarea").each(function (index, inputField) {
        $inputField = $(inputField);

        if ($inputField.data('validation-required') !== 1) {
          value = 'valid';
        } else {
          value = 'invalid_no_error';
        }

        $inputField.trigger("setValidationData", [value]);
      });
    }
  }

  function validateFormField($formField, eventType) {
    var validationData = $formField.data();

    if (typeof $formField === "object") {
      if ((validationData.validationRequired !== 1) && (validationData.emptyOrValidate !== 1)) {
        return true;
      }

      switch (eventType) {
        case "keyup":
          return validateFormFieldOnKeyup($formField, validationData);

        case "focusout": // Never use "onBlur", because not all IE version cope with it - "focusOut" is fine for all browsers
          return validateFormFieldOnBlur($formField, validationData);

        case "validate-before-continue": // Never use "onBlur", because not all IE version cope with it - "focusOut" is fine for all browsers
          validationData.showAllInvalidErrors = true;
          return validateFormFieldOnBlur($formField, validationData);

        default:
          console.log("WARNING: eventType '" + eventType + "' not handled by FormValidation.validateFormField!");
          return false;
      }
    }
  }

  function getFormRowOfFormElement($formElement) {
    var $rowElement = $formElement.closest(".j-validation-group");

    return $rowElement;
  }

  function isRowValidationRequired($formRow) {
    // Check if in the row there aren item to validate
    return $formRow
       .find("input")
       .filter('[data-validation-required]')
       .length > 0;
  }

  function updateEmptyOrValidateFormRowClasses($formRow) {
    var $childInputs = $formRow.find('input[data-empty-or-validate="1"]');
    if (!$childInputs.length) {
      return;
    }

    var empty = true;
    $childInputs.each(function (index, inputField) {
      if ($(inputField).val() !== "") {
        empty = false;
      }
    });
    if (empty) {
      $formRow.removeAttr("data-validation-state");
    }
  }

  function updateFormRowClasses($formRow) {
    if (!isRowValidationRequired($formRow)) {
      updateEmptyOrValidateFormRowClasses($formRow);
      return;
    }

    var $childInputs;
    var allFieldsValid;
    var countChildInputs;
    var countChildRadios;
    var countChildRadiosValid;
    var countChildRadiosUnchecked;
    var countChildSuccesses;

    $childInputs = $formRow.find('input:not([type="hidden"])');
    countChildInputs            = $childInputs.length;
    countChildSuccesses         = $childInputs.filter('[data-validation-state="valid"]').length;
    countChildRadios            = $childInputs.filter(':radio').length;
    countChildRadiosValid       = $childInputs.filter('[data-validation-state="valid"]:radio').length;
    countChildRadiosUnchecked   = $childInputs.filter('[data-validation-state="invalid_no_error"]:radio').length;
    countChildSuccesses         = countChildSuccesses + countChildRadiosUnchecked;
    allFieldsValid              = (countChildSuccesses === countChildInputs) && (countChildRadios === 0 || countChildRadiosValid !== 0);

    if (allFieldsValid) {
      $formRow.trigger("setValidationData", ['valid']);
    } else {
      $formRow.trigger("setValidationData", ['invalid_show_error']);
    }
  }

  function setErrorSummaryForContainer($container, errorSummary) {
    var $errorSummaryContainer;

    if (typeof $container === "object" && typeof errorSummary === "string" && errorSummary.length > 0) {
      $errorSummaryContainer = getErrorSummaryContainer($container);
      $errorSummaryContainer.html(errorSummary);
      $errorSummaryContainer.removeClass("isHidden");
    }
  }

  function removeErrorSummaryForContainer($container) {
    var $errorSummaryContainer;

    if (typeof $container === "object") {
      $errorSummaryContainer = getErrorSummaryContainer($container);
      $errorSummaryContainer.remove();
    }
  }

  function getValidationResultOf($formRows, formRowClassesToValidate) {
    var isSuccess = false;
    var $validationFormRows;
    var $formRowsValidatedOk;

    if (typeof $formRows === 'object') {
      $validationFormRows  = $formRows.filter(formRowClassesToValidate);
      $formRowsValidatedOk = $validationFormRows.filter('[data-validation-state="valid"]');

      isSuccess = ($validationFormRows.length === $formRowsValidatedOk.length);
    }

    return isSuccess;
  }

  function validateCardExpiration(cardType) {
    if (typeof handledCardTypes[cardType] === 'undefined' || handledCardTypes[cardType] !== true) {
      console.error('ERROR: FormValidation.validateCardExpiration has been called with an unsupported card type "' + cardType + '"');
      return false;
    }

    var monthSelected = getExpirationDateFieldValues(cardType, 'month');
    var yearSelected = getExpirationDateFieldValues(cardType, 'year');

    removeExpirationErrorMessages(cardType);

    if (isMonthAndYearFuture(monthSelected, yearSelected)) {
      return true;
    } else {
      showExpirationErrorFor(cardType);
      return false;
    }
  }

  function validatePaymentMethodSubform(paymentMethod) {
    var validationResult;

    switch (paymentMethod) {
      case 'creditcard':
        validationResult = validateCardExpiration(paymentMethod);
        break;
      case 'klarnainvoice':
        validationResult = validateKlarnaSubform();
        break;
      default:
        validationResult = true;
    }

    return validationResult;
  }

  w.THEME.FormValidation = {
    /*! test-code */
    ccNumberInputErrorExists            : ccNumberInputErrorExists,
    getBirthdayDateForKlarna            : getBirthdayDateForKlarna,
    getErrorMessageContainerBelowElement: getErrorMessageContainerBelowElement,
    getErrorSummaryContainer            : getErrorSummaryContainer,
    getExpirationDateFieldValues        : getExpirationDateFieldValues,
    getFieldIdentifierOf                : getFieldIdentifierOf,
    getFormErrorMessageRowFor           : getFormErrorMessageRowFor,
    getOnBlurValidationState            : getOnBlurValidationState,
    getOnKeyUpValidationState           : getOnKeyUpValidationState,
    getValidationState                  : getValidationState,
    hasInvalidCharacters                : hasInvalidCharacters,
    isInputTooShort                     : isInputTooShort,
    isMonthAndYearFuture                : isMonthAndYearFuture,
    removeErrorMessageBelowElement      : removeErrorMessageBelowElement,
    removeExpirationErrorMessages       : removeExpirationErrorMessages,
    setErrorForElement                  : setErrorForElement,
    showErrorMessageBelowElement        : showErrorMessageBelowElement,
    showExpirationErrorFor              : showExpirationErrorFor,
    unsetErrorForElement                : unsetErrorForElement,
    validateFormFieldOnBlur             : validateFormFieldOnBlur,
    validateFormFieldOnKeyup            : validateFormFieldOnKeyup,
    validateKlarnaSubform               : validateKlarnaSubform,
    /*! end-test-code */
    init                                : init,
    getFormRowOfFormElement             : getFormRowOfFormElement,
    getValidationResultOf               : getValidationResultOf,
    initForm                            : initForm,
    isRowValidationRequired             : isRowValidationRequired,
    removeErrorSummaryForContainer      : removeErrorSummaryForContainer,
    setErrorSummaryForContainer         : setErrorSummaryForContainer,
    updateFormRowClasses                : updateFormRowClasses,
    validateCardExpiration              : validateCardExpiration,
    validateFormField                   : validateFormField,
    validatePaymentMethodSubform        : validatePaymentMethodSubform
  };
}(window.jQuery, window));

window.THEME.$document.ready(function documentReadyFunction() {
  'use strict';

  if ($('#checkout').length === 1) {
    window.THEME.FormValidation.init();
  }
});
